/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export const FailurePosture = {
  FailClosed: "fail_closed",
  FailOpen: "fail_open",
} as const;
export type FailurePosture = ClosedEnum<typeof FailurePosture>;

export type CreateInstanceRequestBody = {
  failurePosture?: FailurePosture | undefined;
  name: string;
};

/** @internal */
export const FailurePosture$outboundSchema: z.ZodMiniEnum<
  typeof FailurePosture
> = z.enum(FailurePosture);

/** @internal */
export type CreateInstanceRequestBody$Outbound = {
  failure_posture?: string | undefined;
  name: string;
};

/** @internal */
export const CreateInstanceRequestBody$outboundSchema: z.ZodMiniType<
  CreateInstanceRequestBody$Outbound,
  CreateInstanceRequestBody
> = z.pipe(
  z.object({
    failurePosture: z.optional(FailurePosture$outboundSchema),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      failurePosture: "failure_posture",
    });
  }),
);

export function createInstanceRequestBodyToJSON(
  createInstanceRequestBody: CreateInstanceRequestBody,
): string {
  return JSON.stringify(
    CreateInstanceRequestBody$outboundSchema.parse(createInstanceRequestBody),
  );
}
